import React, { useEffect } from "react";

export default function Dashboard() {
  useEffect(() => {}, []);
  return <div>Welcome letsvoo</div>;
}
